/** Build Klar/checkout articleQuantities payload. Quantity|both lines only. */

const parsePositiveWholeNumber = (raw) => {
  const text = String(raw ?? '').trim();
  if (!/^[1-9]\d*$/.test(text)) {
    return null;
  }
  return Number.parseInt(text, 10);
};

export const buildArticleQuantitiesPayload = (lines, quantities) => {
  const qtyLines = (lines || []).filter(
    (line) => line.unitMode === 'quantity' || line.unitMode === 'both'
  );
  const payload = [];
  for (const line of qtyLines) {
    const raw = quantities[line.id] ?? (line.quantity != null ? String(Math.trunc(Number(line.quantity))) : '1');
    const quantity = parsePositiveWholeNumber(raw);
    if (quantity == null) {
      return { error: true, payload: [] };
    }
    payload.push({ lineId: line.id, quantity });
  }
  return { error: false, payload };
};
